import React from 'react'
import { NavLink, useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { selectTabs, selectHideTabBar } from '@selectors'

import useStyles from './tab-bar.style'

import {
  TAB_TITLE_MESSAGES,
  TAB_TITLE_RESOURCES,
  TAB_TITLE_TIPS
} from '../../assets/i18n/strings'
import i18n from 'i18n-js'

import Icon from '@components/icon/icon.component'
import ResponsiveContainer from '@components/responsive-container/responsive-container.component'

const TabBar = (props) => {
  const tabs = useSelector(selectTabs)

  const hideTabBar = useSelector(selectHideTabBar)

  const classes = useStyles({ ...props, hideTabBar })

  const { personalAccessCode } = useParams()

  const tabTranslations = (title) => {
    switch (title) {
    case 'Messages':
      return i18n.t(TAB_TITLE_MESSAGES)
    case 'Resources':
      return i18n.t(TAB_TITLE_RESOURCES)
    case 'Tips':
      return i18n.t(TAB_TITLE_TIPS)
    default:
      return null
    }
  }
  return (
    <div className={classes.tabBarContainer}>
      <ResponsiveContainer>
        {tabs.map(({ tab }, key) =>
          <NavLink
            key={`button_${key}`}
            activeClassName={classes.selectedLink}
            className={classes.tabBarButton}
            data-testid={`tab-${tab.path}`}
            style={{ display: tab.display ? 'flex' : 'none' }}
            to={`/${personalAccessCode}/${tab.path}`}
          >
            <Icon type={tab.icon} />
            <div className={classes.navText}>{tabTranslations(tab.title)}</div>
          </NavLink>
        )}
      </ResponsiveContainer>
    </div>
  )
}

export default TabBar
